<template>
  <div :class="classes()">
    <div v-if="recommendation" :class="`${el}__recommendation`">{{ recommendation }}</div>
    <div :class="`${el}__top`">
      <Copy element="div" size="l" :staticClass="`${el}__headline`" bold>
        <template>
          {{ headline }}
          <div v-if="infoText" :class="`${el}__tooltip`">
            <Icon
              name="information-line"
              color="primaryBlue"
              :content="infoText"
              v-tippy="{ arrow: true }"
            />
          </div>
        </template>
      </Copy>

      <Copy v-if="typeof copy === 'string'" size="s" color="tertiaryLight">
        {{ copy }}
      </Copy>

      <template v-if="typeof copy === 'object'">
        <Copy v-for="(c, i) in copy" :key="`ToggleTeaserCopy-${i}`" size="s" color="tertiaryLight">
          {{ c }}
        </Copy>
      </template>

      <div :class="`${el}__pricing`">
        <Copy element="div" v-if="priceSmall" size="s" color="tertiaryLight">
          <CountUp :end="priceSmall" />
          {{ $t('cs.analysis.generals.yearly.plain') }}
        </Copy>
        <div v-if="priceAdditional" :class="`${el}__addionalPrice`">
          <Divider dotted />
          <div :class="`${el}__addionalPriceInner`">
            <Copy size="s" color="tertiaryLight" element="div" noWrap>
              {{ priceAdditional.label }}
            </Copy>
            <Copy
              size="s"
              color="tertiaryLight"
              element="div"
              :staticClass="`${el}__addionalPriceCopy`"
            >
              {{ priceAdditional.copy }}
            </Copy>
          </div>
          <Divider dotted />
        </div>
        <Copy element="div" size="l" :staticClass="`${el}__priceBig`" bold>
          <CountUp :end="priceBig" />
          {{ $t('cs.analysis.generals.monthly.plain') }}
        </Copy>
      </div>
    </div>
    <template v-if="toggleSwitch">
      <Divider dotted />
      <div :class="`${el}__bottom`">
        <ToggleSwitch
          v-bind="toggleSwitch"
          @click="onToggleSwitchClick"
          :checked="checked"
          labelOnSamePosition
        />
      </div>
    </template>
  </div>
</template>

<script>
import ToggleSwitch from '@/objects/ToggleSwitch';
import Copy from '@/objects/Copy';
import Icon from '@/objects/Icon';
import Divider from '@/objects/Divider';
import CountUp from '@/objects/CountUp';

export default {
  name: 'ToggleTeaser',
  components: {
    ToggleSwitch,
    Copy,
    Icon,
    Divider,
    CountUp,
  },
  props: {
    headline: String,
    infoText: String,
    copy: [String, Array],
    priceSmall: Number,
    priceAdditional: {
      label: String,
      copy: String,
    },
    priceBig: Number,
    toggleSwitch: {
      inactiveLabel: String,
      activeLabel: String,
    },
    recommendation: String,
    checked: Boolean,
    onToggleSwitchClick: Function,
  },
  data() {
    return {
      el: 'c-toggleTeaser',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--checked`]: this.checked || !this.toggleSwitch,
        };
      },
    };
  },
};
</script>
